// extracted by mini-css-extract-plugin
export default {"wrapper":"App_wrapper__WnIkY","authWrapper":"App_authWrapper__PH7A-","authContent":"App_authContent__ol4ld"};